/* Customer support surface — Norwegian source catalog. */
window.PlummeI18n.register('no', {
  'nav.support': 'Support',
  'navhelp.support': 'Se og følg opp support-saker du har sendt inn.',
  'route.support': 'Support',
  'support.title': 'Support',
  'support.contact': 'Kontakt support',
  'support.close': 'Lukk',
  'support.send': 'Send',
  'support.sending': 'Sender…',
  'support.editor.toolbar': 'Meldingsformatering',
  'support.editor.bold': 'Fet',
  'support.editor.italic': 'Kursiv',
  'support.editor.underline': 'Understreket',
  'support.editor.bullets': 'Punktliste',
  'support.editor.numbered': 'Nummerert liste',
  'support.editor.list': 'Liste',
  'support.editor.link': 'Lenke',
  'support.editor.linkPrompt': 'Lim inn en http://- eller https://-lenke',
  'support.editor.image': 'Bilde',
  'support.editor.screenshot': 'Skjermbilde',
  'support.editor.screenshotLabel': 'Legg ved skjermbilde av gjeldende visning',
  'support.editor.capturing': 'Tar skjermbilde…',
  'support.editor.pendingImages': 'Bilder klare til sending',
  'support.editor.removeImage': 'Fjern bilde',
  'support.editor.openImage': 'Åpne bilde',
  'support.editor.optimizing': 'Optimaliserer bilder…',
  'support.retry': 'Prøv igjen',
  'support.back': 'Tilbake til supportsaker',
  'support.category': 'Kategori',
  'support.category.feil': 'Feil / noe fungerer ikke',
  'support.category.fakturering': 'Fakturering og betaling',
  'support.category.sporsmal': 'Generelt spørsmål',
  'support.category.annet': 'Annet',
  'support.subject': 'Emne',
  'support.subject.placeholder': 'Kort beskrivelse av saken',
  'support.message': 'Melding',
  'support.message.placeholder': 'Beskriv hva som skjer, gjerne med detaljer',
  'support.sent.title': 'Supportsaken er sendt',
  'support.sent.text': 'Vi har mottatt {id} og tar kontakt så snart som mulig.',
  'support.new.title': 'Ny supportsak',
  'support.new.action': 'Ny supportsak',
  'support.filter.label': 'Filtrer supportsaker',
  'support.filter.all': 'Alle',
  'support.filter.open': 'Åpne',
  'support.filter.closed': 'Lukkede',
  'support.table.ticket': 'Sak',
  'support.table.category': 'Kategori',
  'support.table.sent': 'Sendt',
  'support.table.lastReply': 'Siste svar',
  'support.lastReply.you': 'Du',
  'support.lastReply.support': 'Support',
  'support.table.status': 'Status',
  'support.status.open': 'Åpen',
  'support.status.closed': 'Lukket',
  'support.opened': 'Åpnet {date}',
  'support.closeTicket': 'Merk som lukket',
  'support.table.actions': 'Handlinger',
  'support.delete.rowAction': 'Slett',
  'support.delete.rowLabel': 'Slett henvendelse {{id}}',
  'support.delete.action': 'Slett henvendelse',
  'support.delete.title': 'Slette henvendelsen?',
  'support.delete.confirm': 'Slett',
  'support.delete.text': 'Henvendelsen fjernes fra listen din, og meldingene i den blir ikke lenger tilgjengelige for deg.',
  'support.delete.done': 'Henvendelsen er slettet.',
  'support.error.delete': 'Henvendelsen kunne ikke slettes. Prøv igjen.',
  'support.reopen.action': 'Gjenåpne',
  'support.reopen.title': 'Gjenåpne supportsaken?',
  'support.reopen.confirm': 'Åpne likevel',
  'support.reopen.text': 'Gjenåpne kun hvis det gjelder samme problem som saken opprinnelig handlet om. Er det en ny sak, opprett heller en ny supportsak.',
  'support.you': 'Du',
  'support.agent': 'Support',
  'support.reply.placeholder': 'Fortsett samtalen – skriv en melding til support',
  'support.closed.note': 'Denne saken er lukket. Du kan se historikken, men ikke sende flere meldinger.',
  'support.empty.title': 'Ingen support-saker ennå',
  'support.empty.filterTitle': 'Ingen saker i dette filteret',
  'support.empty.text': 'Saker du sender inn via support-knappen dukker opp her.',
  'support.loading.list': 'Henter supportsaker…',
  'support.loading.thread': 'Henter samtalen…',
  'support.error.required': 'Skriv inn både emne og melding.',
  'support.error.noBusiness': 'Velg et foretak før du kontakter support.',
  'support.error.create': 'Kunne ikke sende supportsaken. Prøv igjen.',
  'support.error.list': 'Kunne ikke hente supportsakene.',
  'support.error.thread': 'Kunne ikke hente samtalen.',
  'support.error.reply': 'Kunne ikke sende meldingen. Prøv igjen.',
  'support.error.status': 'Kunne ikke oppdatere statusen.',
  'support.error.link': 'Skriv inn en gyldig http://- eller https://-lenke.',
  'support.error.imageType': 'Bruk bilder i JPEG-, PNG-, GIF- eller WebP-format.',
  'support.error.imageSourceSize': 'Hvert originalbilde kan være maksimalt 20 MB.',
  'support.error.imageSourceTotal': 'Originalbildene kan være maksimalt 40 MB per valg.',
  'support.error.imageCount': 'Du kan legge ved opptil fire bilder.',
  'support.error.imageSize': 'Et bilde er fortsatt større enn 5 MB etter optimalisering.',
  'support.error.imageTotal': 'Optimaliserte bilder kan være maksimalt 10 MB per melding.',
  'support.error.imageOptimize': 'Bildet kunne ikke optimaliseres. Prøv et mindre bilde.',
  'support.error.screenshot': 'Kunne ikke ta skjermbildet. Prøv igjen eller legg ved et bilde manuelt.',
  'support.error.imagesUnavailable': 'Bildesending krever den oppdaterte supporttjenesten. Last inn på nytt og prøv igjen.',
  'support.error.requestTimedOut': 'Supporttjenesten svarte ikke. Prøv igjen.',
  'support.page.tickets': 'Supportsaker',
  'support.page.articles': 'Artikler',
  'support.articles.back': 'Tilbake til artikler',
  'support.articles.search.label': 'Søk i hjelpeartikler',
  'support.articles.categories': 'Kategorier',
  'support.articles.results': 'Artikler funnet: {count}',
  'support.articles.empty.title': 'Fant ingen artikler',
  'support.articles.empty.text': 'Prøv et annet søkeord eller velg en annen kategori.',
  'support.articles.clear': 'Nullstill søk og filter',
  'support.pages.label': 'Velg supportside',
  'support.articles.search.placeholder': 'Søk i hjelpeartikler',
  'support.articles.count.one': '{count} artikkel',
  'support.articles.count.other': '{count} artikler',
  'support.articles.resultsTitle': 'Søkeresultater',
});

window.PlummeI18n.register('no', {
  "err.nativeValidation.backend-support.1": "Ugyldig svar ved sletting av supportsaken.",
});
